"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var loading_bar_service_1 = require("./loading-bar.service");
var operators_1 = require("rxjs/operators");
var Subscription_1 = require("rxjs/Subscription");
var router_1 = require("@angular/router");
exports.EXCLUDED_FOR_LOADING_URLS = new core_1.InjectionToken('EXCLUDED URLS FOR LOADING INTERCEPTOR');
var LoadingInterceptor = /** @class */ (function () {
    function LoadingInterceptor(injector, loadingBarService) {
        this.injector = injector;
        this.loadingBarService = loadingBarService;
        this.requestCount = 0;
        this.navigationRequestCount = 0;
        this.excludedUrls = injector.get(exports.EXCLUDED_FOR_LOADING_URLS, []);
        this.excludedUrls.push('notifications/count', 'classifiers/modification', 'data-import-state', 'comment/count', 'navigate');
    }
    LoadingInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        if (!this.subscriptions) {
            this.subscribeRouterEvents();
        }
        var handleObs = next.handle(request);
        var booleanPromise = this.excluded(request.url);
        booleanPromise.then(function (ignore) {
            if (!ignore) {
                _this.start();
            }
        });
        return handleObs.pipe(operators_1.finalize(function () {
            booleanPromise.then(function (ignore) {
                if (!ignore) {
                    _this.end();
                }
            });
        }));
    };
    LoadingInterceptor.prototype.ngOnDestroy = function () {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    };
    LoadingInterceptor.prototype.subscribeRouterEvents = function () {
        var _this = this;
        this.subscriptions = new Subscription_1.Subscription();
        // retrieving Router here to avoid cyclic dependency issues, because Router uses Interceptors too
        var router = this.injector.get(router_1.Router);
        this.subscriptions.add(router.events
            .filter(function (event) { return event instanceof router_1.NavigationStart || event instanceof router_1.RouteConfigLoadStart; })
            .subscribe(function () {
            _this.requestCount = 0;
            _this.navigationRequestCount++;
            _this.loadingBarService.stop();
            _this.loadingBarService.start();
        }));
        this.subscriptions.add(router.events
            .filter(function (event) { return event instanceof router_1.NavigationEnd || event instanceof router_1.NavigationCancel || event instanceof router_1.RouteConfigLoadEnd; })
            .subscribe(function (event) {
            if (event instanceof router_1.NavigationCancel) {
                _this.navigationRequestCount = 0;
            }
            else {
                _this.navigationRequestCount--;
            }
            if (_this.requestCount === 0 && _this.navigationRequestCount === 0) {
                _this.loadingBarService.stop();
            }
        }));
    };
    LoadingInterceptor.prototype.start = function () {
        if (this.requestCount === 0) {
            this.loadingBarService.start();
        }
        this.requestCount++;
    };
    LoadingInterceptor.prototype.end = function () {
        if (this.requestCount > 0) {
            this.requestCount--;
        }
        if (this.requestCount === 0 && this.navigationRequestCount === 0) {
            this.loadingBarService.stop();
        }
    };
    LoadingInterceptor.prototype.excluded = function (url) {
        var _this = this;
        return new Promise(function (resolve) {
            resolve(_this.excludedUrls.some(function (ignoreUrl) { return url.endsWith(ignoreUrl); }));
        });
    };
    LoadingInterceptor = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [core_1.Injector,
            loading_bar_service_1.LoadingBarService])
    ], LoadingInterceptor);
    return LoadingInterceptor;
}());
exports.LoadingInterceptor = LoadingInterceptor;
//# sourceMappingURL=loading.interceptor.js.map